module.exports = __webpack_public_path__ + "static/img/mode4-1.69693c9b.png";